import React, { useState } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-recaptcha';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [formMessage, setFormMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') setName(value);
    if (name === 'email') setEmail(value);
    if (name === 'message') setMessage(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Add your reCAPTCHA secret key
    const recaptchaSecretKey = 'YOUR_RECAPTCHA_SECRET_KEY';

    // Verify reCAPTCHA before submitting the form
    const recaptchaResponse = await new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(recaptchaSecretKey, { action: 'submit' })
          .then(resolve)
          .catch(reject);
      });
    });

    // Send the form data along with the reCAPTCHA response to your server
    try {
      const response = await axios.post('YOUR_SERVER_ENDPOINT', {
        name,
        email,
        message,
        recaptchaResponse,
      });

      // Reset form fields after successful submission
      setName('');
      setEmail('');
      setMessage('');
      setFormMessage(response.data.message);
    } catch (error) {
      console.error('Form submission error:', error.message);
      setFormMessage('Failed to submit the form. Please try again later.');
    }
  };

  return (
    <section className="contact-style-two">
      <div className="pattern-layer"></div>
      <div className="auto-container">
        <div className="row clearfix">
          <div className="col-lg-6 col-md-12 col-sm-12 content-column">
            <div className="content-box">
              <div className="sec-title">
                <span className="sub-title">Send a Message</span>
                <h2>Contact us today for expert guidance</h2>
                <p>Complete the enquiry form & we will be in touch as soon as possible.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 form-column">
            <div className="form-inner">
              <form onSubmit={handleSubmit} id="contactForm" method="POST">
                <div className="form-group">
                  <input type="text" name="name" value={name} onChange={handleInputChange} placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" name="email" value={email} onChange={handleInputChange} placeholder="Email Address" required />
                </div>
                <div className="form-group">
                  <textarea name="message" value={message} onChange={handleInputChange} placeholder="Your Message" required></textarea>
                </div>
                {/* Add the reCAPTCHA widget here */}
                <div className="form-group">
                  <ReCAPTCHA
                    sitekey="YOUR_RECAPTCHA_SITE_KEY"
                    size="invisible"
                    onChange={() => {}}
                    onExpired={() => {}}
                  />
                </div>
                <div className="form-group">
                  <button type="submit" className="theme-btn btn-two" name="submit">
                    <span>Send</span>
                  </button>
                  <div id="msgSubmit" className="h3 alert-text text-center hidden"></div>
                  <div className="clearfix"></div>
                </div>
              </form>
              {formMessage && <div>{formMessage}</div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
